/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .filter("filecut", function () {
            return function (value, wordwise, max) {
                if (!value) return "";

                max = parseInt(max, 10);
                if (!max) return value;
                if (value.length <= max) return value;

                var extension = value.substr(value.lastIndexOf("."), value.length);
                value = value.substr(0, max);
                if (wordwise) {
                    var lastspace = value.lastIndexOf(" ");
                    if (lastspace !== -1) {
                        if (
                            value.charAt(lastspace - 1) === "." ||
                            value.charAt(lastspace - 1) === ","
                        ) {
                            lastspace = lastspace - 1;
                        }
                        value = value.substr(0, lastspace);
                    }
                }
                return value + "...(" + extension + ")";
            };
        })

})();